import { contentKeys } from 'features/content/api/queryKeys'

export const nodesKeys = {
  replacers: () => [...contentKeys.all, 'replacers'] as const,
}
